export default __webpack_public_path__ + "locales/hy-AM/Errors.json?hash=62b3fab50d3181fea93d685a979df4eb";